import React from 'react';
import classNames from 'classnames';

export interface ICountProps {
    number: number;
    className?: string;
    color: 'grey' | 'green' | 'red' | 'red-medium';
    size: 'sm'| 'm' | 'lg' ;
}

const Count = ({
    color,
    size,
    className,
    number,
}: ICountProps): JSX.Element => {
    const actualSize = size ?? 'sm';
    const actualColor = color ?? 'grey';

    const computedClassName: string = classNames(
        'count',
        {
            [`count--color-${actualColor}`]: true,
            [`count--size-${actualSize}`]: true,
        },
        className,
    );

    return (
        <div className={computedClassName}>
            {number}
        </div>
    );
};

export default Count;
